import React from 'react';

export default function SponsoredContentPolicy() {
  return (
    <div className="bg-white text-gray-800 min-h-screen py-12 px-4">
      <div className="max-w-4xl mx-auto space-y-10">

        <h1 className="text-3xl  text-center font-bold text-purple-600">Sponsored Content & Advertisement Policy</h1>

        <p className="text-gray-700">
          Million2Trillion (M2T) may display sponsored content, advertisements, influencer partnerships, or paid promotions inside the platform. This policy ensures full transparency for all users.
        </p>

        <div className="space-y-6">
          <h2 className="text-2xl font-semibold text-purple-500">Sponsorship & Advertising Eligibility</h2>
          <ul className="list-disc space-y-2 pl-6 text-gray-700">
            <li>All advertisers, sponsors, or promotion partners must pass business verification and brand safety reviews.</li>
            <li>M2T prohibits promotion of illegal trading systems, scam investments, unregulated brokers, or high-risk financial offers.</li>
            <li>All sponsored campaigns must fully comply with global financial advertising regulations based on user jurisdictions.</li>
          </ul>
        </div>

        <div className="space-y-6">
          <h2 className="text-2xl font-semibold text-purple-500">Sponsored Influencer Disclosure</h2>
          <ul className="list-disc space-y-2 pl-6 text-gray-700">
            <li>Any influencer, educator, or trader promoting third-party services inside M2T must fully disclose paid partnership status.</li>
            <li>Undisclosed influencer sponsorship or conflict of interest will lead to account review or potential ban.</li>
          </ul>
        </div>

        <div className="space-y-6">
          <h2 className="text-2xl font-semibold text-purple-500">Sponsored Content Labeling</h2>
          <ul className="list-disc space-y-2 pl-6 text-gray-700">
            <li>All paid placements will clearly display “Sponsored”, “Paid Partnership”, or equivalent disclaimers for full user transparency.</li>
            <li>Native ad design will not intentionally confuse sponsored vs. independent user content.</li>
          </ul>
        </div>

        <div className="space-y-6">
          <h2 className="text-2xl font-semibold text-purple-500">Prohibited Ad Categories</h2>
          <ul className="list-disc space-y-2 pl-6 text-gray-700">
            <li>Ponzi schemes, get-rich-quick programs, unlicensed financial advisors.</li>
            <li>Binary options, gambling platforms, illegal offshore brokerages.</li>
            <li>Any highly misleading or non-compliant financial sales offers.</li>
          </ul>
        </div>

        <p className="text-gray-500 italic pt-6">
          M2T protects verified financial market users from paid manipulation. Our monetization model maintains both advertiser opportunity and verified user trust.
        </p>
      </div>
    </div>
  );
}
